import React from 'react'

function Footer() {
    return (
        <div>
           <div class="container-fluid bg-dark text-white p-3 text-center" style={{position:"fixed",bottom:"0"}}>
                  Indian Railways 2021 - Shri Ramdeobaba College of Engineering and Management, Nagpur
           </div>
        </div>
    )
}

export default Footer
